/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum HttpHeaders {
    Accept = 'Accept',
    Authorization = 'Authorization',
    ContentType = 'Content-Type',
    UiRequest = 'X-Ui-Request',
    RequestedWith = 'X-Requested-With',
    RetryAfter = 'Retry-After',
}
